import Vue from "vue";

import FormGroup from "./FormGroup.vue";
import Loading from "./Loading.vue";
import Snackbar from "./Snackbar.vue";
import Confirmation from "./Confirmation.vue";
import ActionDispatcher from "./ActionDispatcher.vue";
import ImageInput from "./ImageInput.vue";

Vue.component("form-group", FormGroup);
Vue.component("loading", Loading);
Vue.component("snackbar", Snackbar);
Vue.component("confirmation", Confirmation);
Vue.component("action-dispatcher", ActionDispatcher);
Vue.component("image-input", ImageInput);
